import { Formik } from "formik";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import FormDisplay from "./FormDisplay";
import pages from "../../../constants/pages";
import { useAxios, useComponent } from "../../../hooks";
import { objectFromFormData, validationSchema } from "./onboardingObjects";

export default function Form({
  fields,
  brands,
  formData,
  setFormData,
  editState,
  setEditState,
}) {
  const axios = useAxios();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { alert } = useComponent();

  return (
    <Formik
      enableReinitialize
      initialValues={formData}
      validateOnChange
      validationSchema={validationSchema}
      onSubmit={(formData, { setSubmitting }) => {
        axios({
          url: "/user/saveConnectionDetails",
          method: "POST",
          data: objectFromFormData(formData, formData.mappedFields),
          disableRedirect: true,
        }).then((response) => {
          if (response.success) {
            navigate(pages.dpOnBoardingList.route);
            setEditState(false);
            dispatch(alert.success(response.data.message));
          }

          setSubmitting(false);
        });
      }}
    >
      {(formikProps) => (
        <FormDisplay
          fields={fields}
          formikProps={formikProps}
          brands={brands}
          editState={editState}
          setEditState={setEditState}
        />
      )}
    </Formik>
  );
}
